/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
import { ReactElement } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UserRole } from 'common/types';

import {
  AuthorizedRoute,
  Logout,
  LogoutCallback,
  RootPage,
  SigninRedirectCallback,
  SilentRenew,
} from './components';

import { ErrorsPage, UnderConstruction } from 'common/components';

// import { AdminDashboardPage } from 'admin/pages';
import {
  PostedJobManagement,
  ProjectManagement,
  UserManagement,
} from 'admin/components';
import SettingsPage from 'admin/pages/AdminSettingsPage';

const secureElement = (element: ReactElement, role?: UserRole) => (
  <AuthorizedRoute role={role}>{element}</AuthorizedRoute>
);

const routes = createBrowserRouter([
  {
    path: '/',
    element: secureElement(<RootPage />, 'admin'),
    errorElement: <ErrorsPage />,
    children: [
      // {
      //   path: 'admin',
      //   element: secureElement(<AdminDashboardPage />, 'admin'),
      // },
      { index: true, element: secureElement(<UserManagement />, 'admin') },
      { path: 'users', element: secureElement(<UserManagement />, 'admin') },
      {
        path: 'jobPosts',
        element: secureElement(<PostedJobManagement />, 'admin'),
      },
      {
        path: 'projects',
        element: secureElement(<ProjectManagement />, 'admin'),
      },
      {
        path: 'settings',
        element: secureElement(<SettingsPage />, 'admin'),
      },
      {
        path: 'common/',
        children: [
          {
            path: 'under-construction/',
            element: <UnderConstruction />,
          },
          {
            path: 'error-page/',
            element: <ErrorsPage />,
          },
        ],
      },
    ],
  },
  { path: '/signin-oidc', element: <SigninRedirectCallback /> },
  { path: '/logout', element: <Logout /> },
  { path: '/logout/callback', element: <LogoutCallback /> },
  { path: '/silent-renew', element: <SilentRenew /> },
]);

function AppRoutes() {
  return <RouterProvider router={routes} />;
}

export default AppRoutes;
